module.exports = __webpack_public_path__ + "img/wxkf.dbd3c750.png";